import React from 'react';

import { Box, Icon, addWithConfig } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { useCart } from 'hooks/use-cart';
import useIsSignUpAfterCartEnabled from 'hooks/use-is-sign-up-after-cart';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';
import { RunningExperiments, useExperiments } from 'state/experiments';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

const StyledButton = addWithConfig(ActionButton).withConfig({
  _text: {
    color: primitive.bk.$mayoEggWhite,
  },
  _hover: {
    _text: {
      color: primitive.bk.$mayoEggWhite,
    },
  },
  _disabled: {
    _text: {
      color: primitive.$disabledText,
    },
  },
});

const Badge = Box.withConfig({
  position: 'absolute',
  backgroundColor: Styles.color.contrastBackground,
  w: '$5',
  h: '$5',
  borderRadius: Styles.borderRadius,
  right: '-16px',
  bottom: '$3',
  zIndex: Styles.zIndex.top,
  _text: { textAlign: 'center', fontSize: '13px' },
});

export const CartButton = () => {
  const { navigate } = useRouter();
  const { formatMessage } = useIntl();
  const { numberOfItemsInCart } = useCart();
  const hideCartMenu = useIsMobileBreakpoint();

  const isSignUpAfterCartEnabled = useIsSignUpAfterCartEnabled();

  const { openSignInModal, isAuthenticated } = useAuthContext();
  const { logExposure } = useExperiments();

  if (hideCartMenu) {
    return null;
  }

  const handleOnPress = () => {
    if (!isAuthenticated) {
      logExposure(RunningExperiments.SignInUpAfterCart);
    }

    if (isAuthenticated || isSignUpAfterCartEnabled) {
      navigate(routes.cart);
    } else {
      openSignInModal({
        navigateOnSuccessRoute: routes.cart,
      });
    }
  };

  return (
    <StyledButton
      keepIconSize
      variant={ActionButtonVariants.PRIMARY}
      size={ActionButtonSizes.SMALL}
      data-testid="cart-button-desktop"
      onPress={handleOnPress}
      startIcon={<Icon variant="cart" aria-hidden size={4} />}
      accessibilityLabel={formatMessage({ id: 'viewCart' })}
      disabled={numberOfItemsInCart === 0}
    >
      {!!numberOfItemsInCart && <Badge>{numberOfItemsInCart}</Badge>}

      {formatMessage({ id: 'viewCart' })}
    </StyledButton>
  );
};
